import "./Logs.scss";
import Header from "../Header";
import LogContent from "./LogContent";

function Logs() {
  return (
    <>
      <Header />
      <div className="log-container">
        <div className="log-content">
          <LogContent />
        </div>
      </div>
    </>
  );
}

export default Logs;
